function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useHttpGet } from "nood-comp/src/hooks/useHttpGet";
import { getQueryParam } from "nood-comp/src/net/xhr";
import ObjectViewer from "nood-comp/src/comp/object-viewer/ObjectViewer";
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
export default function EventView(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    event = _useState2[0],
    setEvent = _useState2[1];
  useHttpGet({
    path: "/event/".concat(getQueryParam("id"), "?include=all"),
    setter: setEvent
  });
  if (event === void 0 || event === null) {
    return /*#__PURE__*/React.createElement(FlexVertical, {
      style: {
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Spacer, {
      mtop: 50
    }), /*#__PURE__*/React.createElement(SpinnerApple, {
      size: 25,
      strokeSize: 1.5
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, event && /*#__PURE__*/React.createElement(ObjectViewer, {
    obj: event
  }));
}
EventView.propTypes = {
  // proptypes
};
EventView.defaultProps = {
  // default propTypes
};